import React from 'react';
import { Autocomplete, FormControl, FormHelperText, Stack, TextField, Tooltip } from '@mui/material';

interface MappingProps {
	selectedMapping?: string | null;
	setSelectedMapping: (e: string | null) => void;
	errorMessage?: string;
}

const AxiomMappingSelect: React.FC<MappingProps> = ({ setSelectedMapping, selectedMapping, errorMessage }) => {
	const mappingsLoading = false;
	const mappings = ['axiom_default_mapping'];

	return (
		<>
			<Stack direction="row" width={'100%'}>
				<FormControl fullWidth variant="outlined" error={errorMessage !== ''}>
					<Tooltip title={'Select a mapping to use for AXIOM processing'} placement="top">
						<span>
							<Autocomplete
								value={selectedMapping}
								onChange={(_, newVal) => {
									setSelectedMapping(newVal);
								}}
								options={mappings}
								fullWidth
								disabled={mappingsLoading}
								renderInput={(params) => (
									<TextField
										{...params}
										slotProps={{
											htmlInput: { ...params.inputProps, 'aria-label': 'axiom mapping' },
										}}
										label={mappingsLoading ? 'Loading...' : 'AXIOM Mapping'}
										required
									/>
								)}
								data-testid="mapping-selector"
							/>
						</span>
					</Tooltip>
					<FormHelperText>{'Select a mapping to process the AXIOM file with'}</FormHelperText>
				</FormControl>
			</Stack>
		</>
	);
};

export default AxiomMappingSelect;
